// extracted by mini-css-extract-plugin
module.exports = {"dialog":"AgeRange_dialog__2FwoS"};